import React from "react";
import { Link } from "react-router-dom";
import { FaImages,  FaRegUser,FaUserPlus  } from "react-icons/fa";
import "./Dashboard.css"; // Import the CSS file

const Dashboard = () => {
  const dashboardItems = [
    { path: "/gallery-upload", label: "Gallery Upload", icon: <FaImages /> },
    { path: "/upload-hotel", label: "Upload Room", icon: <FaImages /> },
    // { path: "/register", label: "Register User", icon: <FaRegUser /> },
    { path: "/contact-inquiry", label: "Contact Enquiry", icon: <FaUserPlus /> },
    { path: "/booking-inquiry", label: "Booking Enquiry", icon: <FaUserPlus /> },
    { path: "/ad-inquiry", label: "PopUp Enquiry", icon: <FaUserPlus /> },

  ];

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Admin Dashboard</h1>
      <div className="dashboard-grid">
        {dashboardItems.map((item, index) => (
          <Link to={item.path} className="dashboard-card" key={index}>
            <div className="dashboard-icon">{item.icon}</div>
            <div className="dashboard-label">{item.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
